export const ENDPOINTS = {
  ME: "CustomerManagement/Customer/me",
  LOGIN: "CustomerManagement/Customer/login",
  Otp: "CustomerManagement/Customer/otp",
  ONE_TIME_LOGIN: "one-time-login",
  CITY: "EventManagement/citywise-event-count",
  CITY_SEARCH: "EventManagement/get-customer-cities",
  HOME_STATS: "EventManagement/home-stats",
  HOME: "EventManagement/public-event",
  EVENT_DETAILS: "EventManagement/get-event/:slug",
  VENUE_DETAILS: "EventManagement/get-venue-details/:slug",
  GET_CONTESTS: "EventManagement/contests",
  EVENT_CONTEST: "EventManagement/get-contest/:slug",
  CONTEST_LIST: "EventManagement/contests",
  CONTEST_DETAILS: "EventManagement/contests/:slug",
  CONTEST_PARTICIPATE: "EventManagement/contests/:contestId/participate",
  CONTEST_CHECK_PARTICIPATION:
    "EventManagement/contests/:contestId/check-participation",
  GROUP_EVENT: "EventManagement/get-event-group/:slug",
  // Slot booking for recurring shows (parks, attractions)
  SHOW_CALENDAR: "EventManagement/public/shows/:showId/calendar",
  SHOW_SLOTS: "EventManagement/public/shows/:showId/slots",
  CALCULATION: "Discount/calculate-discount-amount",
  ORDER: "Order/create-customer-order",
  PAYMENT: "Payment/order-payment",
  VERIFY_PAYMENT: "Payment/razorpay/verify-order-payment",
  ATTACHMENT: "Attachment",
  CUSTOMER: "customer/CustomerManagement/Customer/:id",
  ORDER_LISTING: "Order/function-customer-orders",
  ORDER_DETAIL: "Order/function-customer-order-details",
  DOWNLOAD_INVOICE: "Order/download-customer-invoice",
  TRANSFER_ORDER_LISTING: "Order/customer-orders-transfers",
  SEND_TICKET: "customer/Order/RegistrationTransfer",
  TRANSFER_TICKET: "Order/ticket-transfer",
  LOGOUT: "CustomerManagement/Customer/logout",
  ORDER_UPDATE: "Order/update-ticket-transfer",
  SEARCH: "EventManagement/search-public-event",
  REGISTRATIONS: "customer/Order/Order/:id",
  GET_CMS_BY_SLUG: "CMS/get-cms-by-slug",
  GET_CMS_HEADER_FOOTER: "CMS/get-cms-header-footer",
  CANCEL_REGISTRATIONS: "Order/cancel-registration",
  REVOKE_TRANSFER: "Order/cancel-ticket-transfer",
  RESPOND_TICKET_REVOKE: "Order/respond-ticket-transfer-revoke",
  THIRD_PART_EVENT: "EventManagement/public-third-party-event",
  THIRD_PARTY_EVENT_REDIRECT: "EventManagement/third-party-events/:id/redirect",
  THIRD_PARTY_PUBLIC_CONFIG: "EventManagement/public-config",
  EVENT_CMS: "CMS/get-all-event-meta",
  NEAREST_CITY: "EventManagement/find-nearby-city",
  CHECK_FOR_ENROLLMENT: "EventManagement/check-customer-enrollment/:id",
  USER_APPLIED_CONTEST: "Order/contest-info",
  USER_CONTEST_DETAILS: "Order/contest-details",
  ARTIST: "Artist/get-artist",
  ARTIST_BY_SLUG: "Artist/get-artist-by-slug/:slug",
  ARTIST_META: "CMS/get-all-artist-meta",
  ORGANIZER_LIST: "Organizer/get-organizers",
  ORGANIZER_DETAIL: "Organizer/get-organizer-detail/:slug",
  GET_SEAT_LAYOUT: "EventManagement/get-layout-seating-details",
  CREATE_SESSION: "EventManagement/create-session",
  DELETE_SESSION: "EventManagement/delete-session",
  GET_ZONE_LAYOUT: "EventManagement/get-event-zones",
  APPLY_FOR_EDITION: "https://tykkit.app.n8n.cloud/webhook/bas-amsta-j",
  DISCOUNT_LIST: "Discount/get-discount-list",
  APPLICATION_WEBVIEW_HELP: "EventManagement/assign-session",
  BLOGS: "CMS/get-blogs",
  CONTACT_US: "CustomerManagement/Customer/contact-us",
};

export const getApiV2Url = (endpoint) => {
  const rawUrl = process.env.NEXT_PUBLIC_API_URL || process.env.API_URL || "";
  const base = rawUrl.includes("/v1")
    ? rawUrl.replace(/\/v1(?=\/|$)/, "/v2").replace(/\/+$/, "")
    : `${rawUrl.replace(/\/+$/, "")}/api/v2`;
  const cleanEndpoint = (endpoint || "").replace(/^\/+/, "");
  return `${base}/${cleanEndpoint}`;
};
